import React from 'react';
import { Button, Modal } from "react-bootstrap";

const ViewModal = ({ show, handleClose, isEdit }) => {

    return (
        <>
            <Modal show={show} onHide={handleClose} size="lg">
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5 text-center">View Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div class="row">
                        <div class="col-md-12 mb-2">
                            <span style={{fontWeight: 'bold'}}>Company Name</span>
                            <p>{isEdit?.company_name}</p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Email</span>
                            <p>{isEdit?.email}</p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Phone:</span>
                            <p>{isEdit?.phone}</p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Description:</span>
                            <p>{isEdit?.description}</p>
                        </div>


                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Created At</span>
                            <p>
                                <span class="badge bg-info">
                                    {isEdit?.created_at}
                                </span>
                            </p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Updated At</span>
                            <p>
                                <span class="badge bg-info">
                                    {isEdit?.updated_at}
                                </span>
                            </p>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer className="border-0">
                    <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ViewModal;